import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getAllData, deleteIdData ,getDataWithType} from "../../../lib/parameters";
import { ParameterTypeSelect } from "../../ui/myselect";
import params from "../../../data/params.json";


export default function AdminParameters() {
  const [parameters, setParameters] = useState([]);
  const [type, setType] = useState("All")
  console.log("params", params);

  const handleDelete = async (id) => {
    const choice = window.confirm(
      'Are You Sure?'
    );
    if (choice) {
      await deleteIdData(id);
      GetData();
      console.log("Delete", id);
      //router.refresh();
    }

  };

  async function GetData() {
    const params = await getAllData();
    setParameters(params);
  }


  function GetTypeDesc(type) {
    const desc = params.find((param) => param.type === type);
    console.log("desc", type, desc);
    
    if (!desc) {
      return "";
    }
    return desc.label;
  }

  async function GetDataWithType() {
    const params = await getDataWithType(type);
    setParameters(params);
  }

  useEffect(() => {
        GetData();
  }, [])


  
  useEffect(() => {
    if (type === "All")
          GetData();
        else
        GetDataWithType();
    console.log("type",type);
  }, [type])

  const essentialheader = (name, buttonname, buttonlink) => {
        return (
          <div className="d-flex p-2 justify-content-between align-items-center">
            <div className="d-flex p-2">
              <h3>{name}</h3>
              <p></p>
            </div>
            <div className="d-flex">
              <div className="ticket-btn-grp">
                    <Link
                      to={buttonlink}
                    >
                      {buttonname}
                    </Link>
                </div>
              </div>
          </div>
      );
    }

  return (
    <div className="col-xl-12 col-md-12">
      <div className="settings-widget profile-details">
        <div className="settings-inner-blk p-0">
          {essentialheader(
            "Parameters",
            "Create New Parameter",
            "/admin/admin-params-edit/Add"
          )}
          <div className="col-4 p-2">
            <ParameterTypeSelect value={type} setValue={setType} page="List"/>
          </div>      
          <div className="comman-space pb-0">
            <div className="settings-invoice-blk table-responsive">
              {/* Invoice info */}
              <table className="table table-hover">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Type</th>
                    <th>Parameter</th>
                    <th>Order</th>
                    <th>isActive</th>
                    <th>&nbsp;</th>
                  </tr>
                </thead>
                <tbody>
                  {parameters.map(function (data) {
                    return (
                      <tr key={data.id}>
                        <td>
                          <Link
                            to="#"
                            className="invoice-no"
                          >
                            {data.id}
                          </Link>
                        </td>
                        <td>{GetTypeDesc(data.type)}</td>
                        <td>{data.pname}</td>
                        <td>{data.order}</td>
                        <td>{data.isActive ? <span className="badge info-low">True</span> : <span className="badge info-high">False</span>}</td>
                        <td>
                          <div className="profile-share d-flex align-items-center justify-content-end">
                            <Link to={`/admin/admin-params-edit/${data.id}`} className="btn btn-success btn-sm">
                              Update
                            </Link>
                            <button className="btn btn-danger btn-sm" onClick={() => handleDelete(data.id)}>
                              Delete
                            </button>
                          </div>
                        </td>
                      </tr>
                    )
                  })}
                </tbody>
              </table>
              {/* Invoice info */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
